import { Typography } from "@mui/material";
import React from "react";

import HNSColors from "../../../../../ui library/HNSColors";

export default function EmptyTimeWindow() {
  return (
    <div className="flex flex-col items-center justify-center gap-1 rounded-[8px] p-6" style={{ backgroundColor: HNSColors.tertiary[900] }}>
      <Typography className="text-center text-xl font-semibold" sx={{ color: HNSColors.primary[500] }}>
        No time slots
      </Typography>
      <Typography className="text-center">Please add a time window</Typography>
    </div>
  );
}
